export const TRANSFER_WORK_ORDER_CLIENT_SELECT =
  'TRANSFER_WORK_ORDER_CLIENT_SELECT';
export const TRANSFER_WORK_ORDER_MESSAGE_MODAL_SHOW =
  'TRANSFER_WORK_ORDER_MESSAGE_MODAL_SHOW';
export const TRANSFER_WORK_ORDER_MODAL_SHOW = 'TRANSFER_WORK_ORDER_MODAL_SHOW';



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/transfer/store/action-types.js